import { c as _c } from "react/compiler-runtime";
import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { WidgetContext } from "../../../../../../main/layout/layout";
import { prevPane } from "../../../store/layout/actions";
import { State } from "../../../store/state";
import { ProgressContainer, ProgressCircle, ProgressLine, HeaderContainer, ActionButton } from "./ProgressBar.style";
import { Dispatch } from "@reduxjs/toolkit";
import { LayoutActionTypes } from "../../../store/layout/types";
export const ProgressBar: React.FC<{
  inline?: boolean;
  numberOfPanes?: number;
}> = t0 => {
  const $ = _c(24);
  const {
    inline,
    numberOfPanes: t1
  } = t0;
  const numberOfPanes = t1 === undefined ? 4 : t1;
  const dispatch = useDispatch();
  const paneNumber = useSelector(_temp);
  const [widgetContext, setWidgetContext] = useContext(WidgetContext);
  const hideBackButton = paneNumber === 0 || paneNumber >= numberOfPanes - 1;
  let points;
  if ($[0] !== numberOfPanes || $[1] !== paneNumber) {
    points = [];
    for (let i = 0; i < numberOfPanes; i++) {
      points.push(<ProgressCircle key={i} filled={(paneNumber >= i).toString()} />);
    }
    $[0] = numberOfPanes;
    $[1] = paneNumber;
    $[2] = points;
  } else {
    points = $[2];
  }
  let t2;
  if ($[3] !== hideBackButton) {
    t2 = hideBackButton.toString();
    $[3] = hideBackButton;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== dispatch) {
    t3 = e => {
      dispatch(prevPane());
      e.currentTarget.blur();
    };
    $[5] = dispatch;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== hideBackButton || $[8] !== t2 || $[9] !== t3) {
    t4 = <ActionButton data-cy="back-button" disabled={hideBackButton} active={t2} onClick={t3}>←</ActionButton>;
    $[7] = hideBackButton;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== points) {
    t5 = points.map(_temp2);
    $[11] = points;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ProgressLine />;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5) {
    t7 = <ProgressContainer>{t5}{t6}</ProgressContainer>;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== inline || $[17] !== setWidgetContext || $[18] !== widgetContext) {
    t8 = !inline && <ActionButton data-cy="close-widget" onClick={e_0 => {
      setWidgetContext({
        ...widgetContext,
        open: false
      });
      e_0.currentTarget.blur();
    }}>✕</ActionButton>;
    $[16] = inline;
    $[17] = setWidgetContext;
    $[18] = widgetContext;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t4 || $[21] !== t7 || $[22] !== t8) {
    t9 = <HeaderContainer>{t4}{t7}{t8}</HeaderContainer>;
    $[20] = t4;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
function _temp(state) {
  return state.layout.paneNumber;
}
function _temp2(p) {
  return p;
}